(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-collection-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fd-collection-offers')) {
    customElements.define('fd-collection-offers', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-offer-track]');
        if (!this.track || this.abort) return;
        this.items = [...this.querySelectorAll('[data-offer-item]')];
        this.prev = this.querySelector('[data-offer-prev]');
        this.next = this.querySelector('[data-offer-next]');
        this.dots = [...this.querySelectorAll('[data-offer-dot]')];
        this.dotGroup = this.querySelector('[data-offer-dots]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const keys = { ArrowLeft: rtl ? 1 : -1, ArrowRight: rtl ? -1 : 1 };
          if (event.key in keys) {
            event.preventDefault();
            this.go(this.index + keys[event.key]);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.maxIndex);
          }
        }, options);
        this.observer = new ResizeObserver(() => this.schedule());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }
      update() {
        if (!this.items.length) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = this.items[0].getBoundingClientRect().width + gap;
        if (!this.step) return;
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.maxIndex = Math.max(0, Math.ceil((this.maxScroll - 2) / this.step));
        const position = Math.abs(this.track.scrollLeft);
        this.index = Math.min(this.maxIndex, Math.round(position / this.step));
        const overflow = this.maxScroll > 3;
        this.prev.hidden = !overflow;
        this.next.hidden = !overflow;
        this.dotGroup.hidden = !overflow;
        this.prev.disabled = position < 3;
        this.next.disabled = position >= this.maxScroll - 3;
        this.dots.forEach((dot, index) => {
          dot.hidden = index > this.maxIndex;
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      go(index) {
        const nextIndex = Math.max(0, Math.min(index, this.maxIndex));
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: direction * Math.min(nextIndex * this.step, this.maxScroll), behavior });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-home-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fd-home-showcase')) {
    customElements.define('fd-home-showcase', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const opts = { signal: this.lifecycle.signal };
        this.track = this.querySelector('.fd-home-track');
        this.controls = this.querySelector('.fd-home-carousel__controls');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        if (this.track && this.controls) {
          const move = direction => {
            const card = this.track.querySelector('.fd-home-card');
            if (!card) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          };
          this.previous.addEventListener('click', () => move(-1), opts);
          this.next.addEventListener('click', () => move(1), opts);
          this.track.addEventListener('scroll', () => this.updateButtons(), {...opts, passive:true});
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track) return;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              move(event.key === 'ArrowRight' ? 1 : -1);
            }
          }, opts);
          this.resize = new ResizeObserver(() => this.updateButtons());
          this.resize.observe(this.track);
          this.updateButtons();
        }
        this.videos = [...this.querySelectorAll('video')];
        this.videos.forEach(video => video.addEventListener('play', () => {
          document.querySelectorAll('fd-home-showcase video').forEach(other => { if (other !== video) other.pause(); });
        }, opts));
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), {threshold:0.05});
        this.videos.forEach(video => this.observer.observe(video));
        document.addEventListener('visibilitychange', () => { if(document.hidden) this.videos.forEach(video => video.pause()); }, opts);
      }
      updateButtons() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 4;
        this.previous.disabled = this.track.scrollLeft < 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fod-aroma-club"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fod-newsletter')) return;

  const KEY = 'fod_club_v1';
  const memory = { seen: false, klaviyo: false, pending: null, closed: 0, subscribed: 0 };
  const read = (type, key) => {
    try { return JSON.parse(window[type].getItem(`${KEY}_${key}`)); }
    catch (_) { return null; }
  };
  const write = (type, key, value) => {
    try { window[type].setItem(`${KEY}_${key}`, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  };
  const remove = (type, key) => {
    try { window[type].removeItem(`${KEY}_${key}`); }
    catch (_) {  }
  };
  const path = () => location.pathname.replace(/\/+$/, '') || '/';
  const visible = (node) => {
    if (!(node instanceof HTMLElement) || node.closest('[hidden]')) return false;
    const style = getComputedStyle(node);
    const rect = node.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 &&
      rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < innerHeight && rect.left < innerWidth;
  };

  class FodNewsletter extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._timers = new Set();
      this._retry = null;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('#FodClubForm');
      this.email = this.querySelector('#FodClubEmail');
      this.launcher = this.querySelector('[data-fod-open]');
      this.invitation = this.querySelector('[data-fod-invitation]');
      this._invited = false;
      this._dismissed = false;
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      const previewMode = new URLSearchParams(location.search).get('fod_popup_preview');
      this.preview = previewMode === '1' || previewMode === 'invite';
      this.editor = Boolean(window.Shopify && window.Shopify.designMode);
      this.delay = Math.max(5, Number(this.dataset.delay) || 15) * 1000;
      this.readyAt = Date.now() + this.delay;
      this.dialog.setAttribute('tabindex', '-1');
      const on = (target, event, handler, options = {}) => {
        target.addEventListener(event, handler, { ...options, signal: this._abort.signal });
      };
      this.querySelectorAll('[data-fod-close]').forEach((button) => {
        on(button, 'click', () => this.dismiss());
      });
      if (this.launcher) on(this.launcher, 'click', () => this.open(false));
      const dismissInvitation = this.querySelector('[data-fod-dismiss-invitation]');
      if (dismissInvitation) on(dismissInvitation, 'click', () => this.dismiss());
      on(this.dialog, 'cancel', (event) => { event.preventDefault(); this.dismiss(); });
      on(this.dialog, 'pointerdown', (event) => {
        this._backdropDown = event.target === this.dialog && this.outside(event);
      });
      on(this.dialog, 'click', (event) => {
        if (this._backdropDown && event.target === this.dialog && this.outside(event)) this.dismiss();
        this._backdropDown = false;
      });
      on(this.dialog, 'close', () => this.restoreFocus());
      if (this.form) on(this.form, 'submit', (event) => {
        if (this.preview || this.editor) { event.preventDefault(); return; }
        if (!this.form.checkValidity()) return;
        const nonce = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
          `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        memory.pending = { nonce, time: Date.now(), path: path() };
        write('sessionStorage', 'pending', memory.pending);
      });
      on(document, 'submit', (event) => {
        const form = event.target;
        if (this.preview || this.editor || !(form instanceof HTMLFormElement) || form === this.form) return;
        if (form.querySelector('input[name="form_type"][value="customer"]')) {
          memory.pending = null;
          remove('sessionStorage', 'pending');
        }
      }, { capture: true });
      on(document, 'shopify:section:select', (event) => {
        if (this.editor && (event.target === this || event.target.contains(this))) this.open(true, true);
      });
      on(document, 'shopify:section:deselect', (event) => {
        if (this.editor && (event.target === this || event.target.contains(this))) this.close();
      });
      on(window, 'scroll', () => this.consider(), { passive: true });
      on(document, 'visibilitychange', () => this.consider());
      on(window, 'storage', (event) => {
        if (event.key !== `${KEY}_seen` && event.key !== `${KEY}_subscribed`) return;
        if (event.newValue) {
          memory.seen = true;
          this._dismissed = true;
          if (this.invitation) this.invitation.hidden = true;
        }
      });

      if (this.preview) {
        if (previewMode === 'invite' && this.invitation) this.invitation.hidden = false;
        else this.later(() => this.open(true, true), 0);
        return;
      }
      if (this.handleResult()) return;
      if (this.editor || this.excluded() || this.isSubscribed() || this.hasSeen()) return;
      this.later(() => this.consider(), this.delay);
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
      this._abort = null;
      if (this._timers) this._timers.forEach(clearTimeout);
      this._timers = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.restoreFocus();
    }

    later(callback, delay) {
      const timer = setTimeout(() => {
        if (this._timers) this._timers.delete(timer);
        if (this.isConnected) callback();
      }, delay);
      this._timers.add(timer);
      return timer;
    }

    excluded() {
      return /\/(cart|account|policies|challenge|checkpoint|checkouts?)(\/|$)/i.test(path());
    }

    isSubscribed() {
      const stamp = Number(read('localStorage', 'subscribed')) || memory.subscribed;
      return this.dataset.subscribed === 'true' || stamp > 0;
    }

    hasSeen() {
      const seen = memory.seen || Boolean(read('localStorage', 'seen')) ||
        Boolean(read('localStorage', 'closed')) || Boolean(read('sessionStorage', 'seen'));
      if (seen && !read('localStorage', 'seen')) write('localStorage', 'seen', Date.now());
      return seen;
    }

    markSeen() {
      if (!write('localStorage', 'seen', Date.now())) return false;
      memory.seen = true;
      write('sessionStorage', 'seen', true);
      return true;
    }

    handleResult() {
      if (this.preview || this.editor) return false;
      const pending = read('sessionStorage', 'pending') || memory.pending;
      const age = pending ? Date.now() - Number(pending.time) : NaN;
      const freshPending = pending && typeof pending.nonce === 'string' && pending.nonce.length > 0 &&
        Number.isFinite(age) && age >= 0 && age <= 30 * 60000 &&
        (pending.path === path() || /(^|\/)contact$/.test(path()));
      if (pending && (!Number.isFinite(age) || age < 0 || age > 30 * 60000)) {
        memory.pending = null;
        remove('sessionStorage', 'pending');
      }
      const result = this.querySelector('[data-fod-result="success"], [data-fod-result="error"]');
      if (!result || (!freshPending && location.hash !== '#FodClubForm')) return false;
      memory.pending = null;
      remove('sessionStorage', 'pending');
      if (result.dataset.fodResult === 'success') {
        memory.subscribed = Date.now();
        write('localStorage', 'subscribed', memory.subscribed);
        if (this.invitation) this.invitation.hidden = true;
      }
      this.later(() => this.open(true, true), 0);
      return true;
    }

    blockers() {
      const selectors = [
        'dialog[open]', '[aria-modal="true"]', '.tingle-modal--visible',
        '.drawer.active', '.drawer.is-open', '.drawer.open', '[data-drawer][open]',
        '#shopify-pc__banner', '.shopify-pc__banner', '#shopify-pc__prefs',
        '#onetrust-banner-sdk', '#CybotCookiebotDialog', '.cc-window', '.cmplz-cookiebanner',
        '.klaviyo-form [role="dialog"]', '[data-testid="klaviyo-form"] [role="dialog"]'
      ];
      let blocked = false;
      for (const node of document.querySelectorAll(selectors.join(','))) {
        if (this.contains(node) || !visible(node)) continue;
        const klaviyo = node.matches('[class*="klaviyo"], [class*="kl-private"]') ||
          node.closest('[class*="klaviyo"], [class*="kl-private"]') ||
          node.querySelector('[class*="klaviyo"], [class*="kl-private"], [data-testid*="klaviyo"]');
        if (klaviyo) {
          memory.klaviyo = true;
          if (!this.preview && !this.editor) write('sessionStorage', 'klaviyo', true);
        }
        blocked = true;
      }
      return blocked;
    }

    consider() {
      if (this.preview || this.editor || this._dismissed || this.excluded() || this.isSubscribed()) return;
      if (this._invited || this.dialog.open) {
        const blocked = this.blockers();
        if (blocked && this.dialog.open) { this.dismiss(); return; }
        if (this.invitation) this.invitation.hidden = this.dialog.open || blocked ||
          document.visibilityState !== 'visible' || memory.klaviyo;
        if (memory.klaviyo) { this._dismissed = true; return; }
        this.retry();
        return;
      }
      if (this.hasSeen() || memory.klaviyo || read('sessionStorage', 'klaviyo') || !this.invitation) return;
      if (document.visibilityState !== 'visible' || Date.now() < this.readyAt) return;
      const scrollable = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - innerHeight;
      if (scrollable > 100 && scrollY / scrollable < 0.25) return;
      if (this.blockers()) {
        if (!memory.klaviyo) this.retry();
        return;
      }
      if (!this.markSeen()) { this._dismissed = true; return; }
      this._invited = true;
      this.invitation.hidden = false;
      this.retry();
    }

    retry() {
      if (this._retry) return;
      this._retry = this.later(() => {
        this._retry = null;
        this.consider();
      }, 1000);
    }

    open(automatic, force = false) {
      if (!this.dialog || this.dialog.open || !this.isConnected) return;
      if (!force && (this.excluded() || this.isSubscribed() || this.blockers())) return;
      this._previousFocus = document.activeElement;
      this.dialog.setAttribute('autofocus', '');
      try { this.dialog.showModal(); } catch (_) { return; }
      this.dialog.focus({ preventScroll: true });
      this.dialog.removeAttribute('autofocus');
      const photo = this.querySelector('template[data-fod-photo]');
      if (photo) photo.replaceWith(photo.content.cloneNode(true));
      if (!this.preview && !this.editor) {
        this.markSeen();
        memory.seen = true;
        write('sessionStorage', 'seen', true);
      }
      if (this.invitation) this.invitation.hidden = true;
      if (!automatic && this.email && !matchMedia('(pointer: coarse)').matches) {
        this.email.focus({ preventScroll: true });
      }
    }

    outside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom;
    }

    dismiss() {
      this._dismissed = true;
      if (this.invitation) this.invitation.hidden = true;
      if (!this.preview && !this.editor) {
        this.markSeen();
        memory.closed = Date.now();
        write('localStorage', 'closed', memory.closed);
      }
      this.close();
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    restoreFocus() {
      if (this._previousFocus instanceof HTMLElement && this._previousFocus.isConnected) {
        this._previousFocus.focus({ preventScroll: true });
      }
      this._previousFocus = null;
    }
  }

  customElements.define('fod-newsletter', FodNewsletter);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fod-store-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('.fod-store-reviews').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.fod-store-reviews__track');
      const all = section.querySelector('[data-fod-all-reviews]');
      const controls = section.querySelector('.fod-store-reviews__controls');
      const previous = section.querySelector('[data-fod-review-prev]');
      const next = section.querySelector('[data-fod-review-next]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        controls.hidden = section.classList.contains('is-expanded') || track.scrollWidth <= track.clientWidth + 2;
      };
      all.hidden = false;
      all.addEventListener('click', () => {
        const expanded = section.classList.toggle('is-expanded');
        all.setAttribute('aria-expanded', String(expanded));
        all.textContent = expanded ? all.dataset.lessLabel : all.dataset.allLabel;
        track.scrollLeft = 0;
        update();
      });
      [previous, next].forEach((button, index) => button.addEventListener('click', () => {
        const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: (index ? 1 : -1) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
